import React, { useState, useEffect } from "react";

const MobileInstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if already installed
    const isInstalled =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone ||
      document.referrer.includes("android-app://");

    if (isInstalled) {
      return; // Don't show if already installed
    }

    // Check if dismissed in this session
    const wasDismissed = sessionStorage.getItem(
      "noryq-mobile-banner-dismissed",
    );
    if (wasDismissed) {
      return;
    }

    // Check if mobile device (small screen)
    const isMobile = window.innerWidth < 768;

    if (!isMobile) {
      return; // Only show on mobile
    }

    // Listen for install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    // Also show after 3 seconds if no prompt (for iOS)
    const timer = setTimeout(() => {
      if (!deferredPrompt) {
        setShow(true);
      }
    }, 3000);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      clearTimeout(timer);
    };
  }, [deferredPrompt]);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      // Show iOS instructions
      const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
      if (isIOS) {
        alert(
          'To install on iPhone:\n1. Tap Share button (□↑)\n2. Tap "Add to Home Screen"\n3. Tap "Add"',
        );
      } else {
        alert(
          'To install:\nTap your browser menu → "Install app" or "Add to Home screen"',
        );
      }
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      setShow(false);
    }

    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setDismissed(true);
    setShow(false);
    sessionStorage.setItem("noryq-mobile-banner-dismissed", "true");
  };

  if (!show || dismissed) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 9999,
        animation: "slideDown 0.3s ease-out",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.75rem 1rem",
          gap: "0.75rem",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: 40,
            height: 40,
            flexShrink: 0,
            background: "rgba(255,255,255,0.2)",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
            <path d="M9 10l3 3 3-3" />
            <line x1="12" y1="7" x2="12" y2="13" />
          </svg>
        </div>

        {/* Text */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: "0.875rem",
              fontWeight: "700",
              color: "#fff",
              marginBottom: "0.125rem",
            }}
          >
            Install NORYQ
          </div>
          <div
            style={{
              fontSize: "0.75rem",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Quick access from home screen
          </div>
        </div>

        {/* Install Button */}
        <button
          onClick={handleInstall}
          style={{
            padding: "0.5rem 1rem",
            background: "#fff",
            color: "#667eea",
            border: "none",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "0.875rem",
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          Install
        </button>

        {/* Close Button */}
        <button
          onClick={handleDismiss}
          style={{
            width: 28,
            height: 28,
            flexShrink: 0,
            background: "rgba(255,255,255,0.15)",
            border: "none",
            borderRadius: "50%",
            color: "#fff",
            fontSize: "1.25rem",
            lineHeight: 1,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ×
        </button>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default MobileInstallBanner;
